import { CATEGORIE_PRODUIT } from '@/configuration/catalogue/produitConf';
import i18n from '@/i18n';

export default function getLibelleAvecCategorieProduit(piece) {
  if (!piece.libelle) return '';
  const categorieProduit = CATEGORIE_PRODUIT.find((categorie) => {
    return piece.libelle.includes('{'
      + categorie.code.replace(/(?:\/)([A-Z])/mg, '_$1').toLowerCase()
      + '}');
  });
  return categorieProduit ? piece.libelle.replace('{'
    + categorieProduit.code.replace(/(?:\/)([A-Z])/mg, '_$1').toLowerCase()
    + '}', i18n.t(categorieProduit.libelle)) : piece.libelle;
}
